@if (!message.Payload.IsPassword || message.Direction == 'BotToUser') {
  <div class="message-container" [innerHTML]="safeHtml">
  </div>
}
@if (message.Payload.IsPassword && message.Direction != 'BotToUser') {
  <div>
    ****
  </div>
}
